<template>
  <!-- 申请发票 -->
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @close="close"
    append-to-body
    width="60%"
  >
    <div style="margin: 20px 0; text-align: center">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-card
            shadow="hover"
            @click.native="typeOne"
            :class="{ elCard: invoiceType == 0 }"
          >
            增值税普通发票
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card
            shadow="hover"
            @click.native="typeTwo"
            class=""
            :class="{ elCard: invoiceType == 1 }"
          >
            增值税专用发票
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      :rules="rules"
      style=""
    >
      <div class="title">申请信息</div>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="订单号：">
            <el-input
              v-model="form.orderNum"
              disabled
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="保证金金额：">
            <el-input
              v-model="form.guaMoney"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="订单金额：">
            <el-input
              v-model="form.orderFee"
              disabled
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="开票金额：">
            <el-input
              v-model="form.orderFee"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称：">
            <el-input
              v-model="form.projectName"
              disabled
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="标段名称：">
            <el-input v-model="form.bidName" disabled></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="申请时间：">
            <el-input
              v-model="form.orderCreateTime"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0;
        "
      >
        <div class="title">开票信息</div>

        <!-- <div>
          <span style="color: #067efd"
            >*下方开票信息为当前账号发票认证信息，如需修改请点击右侧修改按钮进行修改</span
          >
          <el-button
            style="margin-left: 20px"
            type="primary"
            size="small "
            @click="editBtn"
            >修改</el-button
          >
        </div> -->
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="企业名称：">
            <el-input
              v-model="form.warrantee"
              disabled
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码：">
            <el-input
              v-model="form.warranteeCode"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="注册地址：">
            <el-input
              v-model="form.warranteeAddress"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户行名称：" prop="bankName">
            <el-input v-model="form.bankName"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="电话：" prop="invoicePhone">
            <el-input v-model="form.invoicePhone"></el-input> </el-form-item
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="开户行基本账号：" prop="bankCode">
            <el-input v-model="form.bankCode"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱：" prop="invoiceEmail">
            <el-input v-model="form.invoiceEmail"></el-input> </el-form-item
        ></el-col>
      </el-row>
      <div v-if="invoiceType == 1">
        <div class="title">邮寄信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="收件人姓名：" prop="recipientName">
              <el-input v-model="form.recipientName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件地址：" prop="recipientAddress">
              <el-input
                v-model="form.recipientAddress"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="收件人手机：" prop="recipientPhone">
              <el-input v-model="form.recipientPhone"></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="邮编：" prop="recipientPostCode">
              <el-input
                v-model="form.recipientPostCode"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </div>
      <div style="text-align: center; margin-top: 20px; margin-bottom: 20px">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="onSubmit">提交申请</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import { applyInfoice } from "../../apis/project/index";
export default {
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    const emailRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电子邮箱"));
      } else {
        const reg =
          /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入有效的电子邮箱"));
        }
      }
    };
    const bankNameRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入开户行"));
      } else {
        const reg = /^[\u4e00-\u9fa5\（\）\(\)]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("开户行只能为汉字或汉字+（）"));
        }
      }
    };
    const bankCodeRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入开户行基本账号"));
      } else {
        const reg = /^[0-9]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("开户行基本账号必须为数字"));
        }
      }
    };
    const recipientRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入收件人姓名"));
      } else {
        const reg = /^[\u4e00-\u9fa5]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("收件人姓名必须为2~4位汉字"));
        }
      }
    };
    return {
      invoiceType: 0,
      // special: false,
      form: {
        orderIdint: "",
        orderNum: "",
        guaMoney: "",
        projectName: "",
        guaMoney: "",
        bidName: "",
        orderFee: "",
        orderCreateTime: "",
        warrantee: "",
        warranteeCode: "",
        warranteeAddress: "",
        bankName: "",
        bankCode: "",
        invoicePhone: "",
        invoiceEmail: "",
        recipientName: "",
        recipientPhone: "",
        recipientAddress: "",
        recipientPostCode: "",
      },
      editFlag: "0",
      rules: {
        bankName: [
          { required: true, validator: bankNameRule, trigger: "blur" },
        ],
        invoicePhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
        bankCode: [
          { required: true, validator: bankCodeRule, trigger: "blur" },
        ],
        invoiceEmail: [
          { required: true, validator: emailRules, trigger: "blur" },
        ],
        recipientName: [
          { required: true, validator: recipientRule, trigger: "blur" },
          { min: 2, max: 4, message: "收件人姓名必须为2~4位汉字" },
        ],
        recipientAddress: [
          { required: true, message: "请输入收件地址", trigger: "blur" },
        ],
        recipientPhone: [
          { required: true, validator: phoneRules, trigger: "blur" },
        ],
        recipientPostCode: [
          { required: true, message: "请输入邮编", trigger: "blur" },
        ],
      },
      closePop: true,
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    formData: {
      handler(v) {
        if (v) {
          this.form = v;
        }
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(v) {
        this.$emit("update:dialogVisible", v);
      },
    },
  },
  methods: {
    typeOne() {
      // this.special = false;
      this.invoiceType = 0;
    },
    typeTwo() {
      this.invoiceType = 1;
      // this.special = !this.special;
    },
    back() {
      this.visible = false;
      // this.$router.push("/administration");
    },
    // editBtn() {
    //   (this.editFlag = "1"), (this.isEditBtn = false);
    // },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          applyInfoice({
            userId: Number(window.sessionStorage.getItem("userId")),
            orderId: this.form.orderId,
            invoiceType: this.invoiceType,
            editFlag: "1",
            companyName: this.form.warrantee,
            companyCode: this.form.warranteeCode,
            companyAddress: this.form.warranteeAddress,
            bankName: this.form.bankName,
            bankCode: this.form.bankCode,
            invoicePhone: this.form.invoicePhone,
            email: this.form.invoiceEmail,
            recipient: this.form.recipientName,
            recipientPhone: this.form.recipientPhone,
            recipientAddress: this.form.recipientAddress,
            recipientZipCode: this.form.recipientPostCode,
            //如果为大家财传3 否则穿空
            guarantorId:this.form.guarantorId=='3'?this.form.guarantorId:''
          }).then((res) => {
            if (res.data.status == 1) {
              this.visible = false;
              this.$emit("closePop", this.closePop);
              // this.$router.push("/administration");
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        }
      });
    },
    close() {
      this.invoiceType = 0;
      // this.editFlag = "0";
    },
  },
  mounted() {},
  components: {},
};
</script>

<style scoped>
.page {
  background-color: #fff;
  height: 100%;
  margin: 0 20px;
}
.elCard {
  background-color: #017eff !important;
  color: #fff;
  border: 0 !important;
}
::v-deep .el-card {
  border: #000000 solid 1px;
  cursor: pointer;
}
</style>
